import { IoTrendingDown, IoTrendingUp } from "react-icons/io5";

const Card = ({ heading, count, diff, isDiffNA }) => {
  const previous = (count || 0) - (diff || 0);
  const percentage =
    previous === 0 ? (diff > 0 ? 100 : 0) : ((diff || 0) / previous) * 100;

  return (
    <div className="bg-white flex-1 p-4 pr-5 min-w-[200px] max-w-[300px] rounded-xl shadow-sh">
      <p className="text-base font-semibold">{heading}</p>
      <div className="flex gap-3 justify-between items-end">
        <p className="text-2xl font-semibold mt-1">{count}</p>
        {isDiffNA ? (
          <p className="text-base text-gray-600 font-medium">--</p>
        ) : (
          <div className="flex items-center gap-1.5">
            {diff > 0 ? (
              <IoTrendingUp size={30} color="#40B2B7" />
            ) : (
              <IoTrendingDown size={30} color="#E02734" />
            )}
            <p
              style={{
                color: diff > 0 ? "#40B2B7" : "#E02734",
              }}
              className="text-base"
            >
              {~~Math.round(percentage)}%
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const Cards = ({
  jobCounts,
  previousJobCounts,
  openJobsCounts,
  previousOpenJobCounts,
  isDiffNA,
}) => {
  return (
    <div className="flex gap-5 items-center mt-4">
      <Card
        heading="Total Positions Posted"
        count={jobCounts.positionCount}
        diff={jobCounts.positionCount - previousJobCounts.positionCount}
        isDiffNA={isDiffNA}
      />
      <Card
        heading="Total Open Positions"
        count={openJobsCounts.positionCount}
        diff={
          openJobsCounts.positionCount - previousOpenJobCounts.positionCount
        }
        isDiffNA={isDiffNA}
      />
      <Card
        heading="Total Applications"
        count={jobCounts.applicationCount}
        diff={jobCounts.applicationCount - previousJobCounts.applicationCount}
        isDiffNA={isDiffNA}
      />
      <Card
        heading="Total Open Offers"
        count={jobCounts.offerCount}
        diff={jobCounts.offerCount - previousJobCounts.offerCount}
        isDiffNA={isDiffNA}
      />
      <Card
        heading="Total Hires"
        count={jobCounts.hiredCount}
        diff={jobCounts.hiredCount - previousJobCounts.hiredCount}
        isDiffNA={isDiffNA}
      />
    </div>
  );
};

export default Cards;
